module.exports = __webpack_public_path__ + "bc.no2.cb344523.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/bc.no2.jpg
// module id = 6CMK
// module chunks = 0